export default "__VITE_ASSET__84a7af95__"